export default "__VITE_ASSET__DXYIGt6H__"